import Grid from '@mui/material/Grid';
import type { SxProps } from '@mui/material/styles';
import { useMemo, useState } from 'react';

import { StyledListContainerGrid } from './components/ListContainerGrid.styled';
import { Header } from './header/Header';
import type { ActionType, BaseListOption, EnrichedListOption } from './types';
import type { VirtualizedReadOnlyFlatListProps } from './virtualList/VirtualizedReadOnlyFlatList';
import { VirtualizedReadOnlyFlatList } from './virtualList/VirtualizedReadOnlyFlatList';

type FlatListReadOnlyProps<T> = {
  data: [T, ...T[]];
  actionType: ActionType;
  customSearch?: (data: T[], searchInput: string) => T[];
  customItem?: VirtualizedReadOnlyFlatListProps<T>['customItem'];
  itemSize?: number;
  containerStyles?: SxProps;
  customPlaceholder?: string;
};

export const FlatListReadOnly = <T extends EnrichedListOption<BaseListOption>>({
  data,
  actionType,
  customSearch,
  customItem,
  itemSize,
  containerStyles,
  customPlaceholder,
}: FlatListReadOnlyProps<T>) => {
  const [searchInput, setSearchInput] = useState<string>('');

  const searchedData = useMemo(() => {
    if (customSearch) {
      return customSearch(data, searchInput);
    }

    return data.filter(obj => obj.name.toLowerCase().includes(searchInput.toLowerCase()));
  }, [data, searchInput, customSearch]);

  return (
    <Grid size={6} sx={containerStyles}>
      <StyledListContainerGrid>
        <Header
          searchInput={searchInput}
          setSearchInput={setSearchInput}
          itemAmount={searchedData.length}
          isSelectedList={false}
          isDisabled={false}
          customPlaceholder={customPlaceholder}
        />
        <VirtualizedReadOnlyFlatList
          data={searchedData}
          searchInput={searchInput}
          actionType={actionType}
          customItem={customItem}
          itemSize={itemSize}
        />
      </StyledListContainerGrid>
    </Grid>
  );
};
